import { Link } from 'react-router-dom'
import { useCategoriesRedux } from '../../../../hooks/useCategoriesRedux'
import Image from '../../../ui/Image/Image'
import s from './CategoriesCatalog.module.css'

// Скелетон для категорії
const CategorySkeleton = () => (
  <div className={s.categorySkeleton}>
    <div className={s.imageWrapperSkeleton}>
      <div className={s.imageSkeleton}></div>
    </div>
    <div className={s.contentSkeleton}>
      <div className={s.titleSkeleton}></div>
    </div>
  </div>
)

export default function CategoriesCatalog() {
  const { categories, loading } = useCategoriesRedux()

  if (loading) {
    return (
      <div className={s.categoriesCatalog}>
        {[...Array(6)].map((_, index) => (
          <CategorySkeleton key={index} />
        ))}
      </div>
    )
  }

  if (categories.length === 0) {
    return <div>No categories</div>
  }

  return (
    <div className={s.categoriesCatalog}>
      {categories.map(category => (
        <Link
          to={`/shop/${category.internalName}`}
          key={category.internalName}
          className={s.category}
        >
          <div className={s.imageWrapper}>
            <Image
              src={category.imageUrl}
              alt={category.externalName}
              sizes="9.33vw"
            />
          </div>
          <div className={s.content}>
            <h3>{category.externalName}</h3>
          </div>
        </Link>
      ))}

      {/* Hidden: Sales category link */}
      {/* <Link to={`/shop/sales`} key={`sales`} className={s.category}>
        <div className={s.imageWrapper}>
          <img
            src={'/images/sales.png'}
            alt={'sales'}
            onError={e => {
              const target = e.target as HTMLImageElement
              target.src = '/images/product.png' // Fallback image
            }}
          />
        </div>
        <div className={s.content}>
          <div className={s.iconWrapper}>
            <img
              src={'/images/sales.png'}
              alt={`sales icon`}
              onError={e => {
                const target = e.target as HTMLImageElement
                target.style.display = 'none'
              }}
            />
          </div>
          <h3>Акції</h3>
        </div>
      </Link> */}
    </div>
  )
}
